import script from "./CreateEntitlementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEntitlementModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateEntitlementModal.vue?vue&type=style&index=0&id=b788cd4c&scoped=true&lang=css"
script.__scopeId = "data-v-b788cd4c"

export default script